import { Box, Grid, SxProps, Typography } from "@mui/material";
import { red } from "@mui/material/colors";
import { FC, useContext } from "react";
import { StateContext } from "../../context/ApplicationContext";
import { PPComponent, SectionConfiguration } from "../model/form-configuration";

const style: SxProps = {
  padding: 2,
};

const PPSection: FC<{
  children: PPComponent[];
  show: boolean;
  section: SectionConfiguration;
}> = ({ children, show, section }) => {
  const stateCtx = useContext(StateContext);
//   console.log(section.id)
//   console.log( stateCtx.applicationContext.sectionState.errorState[section.id] );
  return (
    <Box sx={{ ...style }}>
      {!stateCtx.applicationContext.sectionState.errorState[section.id] ? (
        <Typography sx={{ color: red.A700 }}>
          Please fix all errors on this section before proceeding
        </Typography>
      ) : null}
      <Grid
        container
        spacing={{ xs: 1, sm: 1, md: 1, lg: 1, xl: 1 }}
        columns={{ xs: 1, sm: 2, md: 4, lg: 4, xl: 4 }}
        justifyContent="flex-start"
      >
        {show &&
          children.map((comp) => {
            return comp.node;
          })}
      </Grid>
    </Box>
  );
};

export default PPSection;
//PPSection.whyDidYouRender = true;
